<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation ref="navigation"></navigation>
    </div>
    <div class="sy_main">
      <div class="sy_position">您当前的位置：
        <router-link :to="{ path: '/'}">首页</router-link> &gt;&gt; 学分查询
      </div>
      <div class="sym_content2">
        <div align="center" class="symc2">
          <h1 style="line-height: 100px">学分查询</h1>
          <div class="loginModule">
            <el-form ref="searchForm" :inline="true" :model="searchForm" :rules="searchFormRule">
              <el-form-item label="年份" prop="year">
                <el-date-picker
                  v-model="searchForm.year"
                  :picker-options="pickerOptions"
                  align="right"
                  format="yyyy"
                  placeholder="选择年"
                  type="year"
                  value-format="yyyy">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="证件号码" prop="sertId">
                <el-input v-model="searchForm.sertId" placeholder="" style="width: 225px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchButtonMainInit()">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="showSearchResult" class="searchResultModule">
            <div class="searchStudentModule">
              <span class="studentTitle">姓名：</span>
              <span>{{ searchFormResult.user.realName }}</span>
              <span class="studentTitle">性别：</span>
              <span>{{ searchFormResult.user.sex == 1 ? '男' : '女' }}</span>
              <span class="studentTitle">身份证号：</span>
              <span>{{ searchFormResult.user.sertId }}</span>
              <span class="studentTitle">科室：</span>
              <span>{{ searchFormResult.user.departmentName }}</span>
              <p>
                <span class="studentTitle">单位：</span>
                <span>{{ searchFormResult.user.companyName }}</span>
              </p>
            </div>
            <el-table :data="searchFormResult.list" border style="width:100%;" class="searchResultModuleTable" :max-height="maxheight">
              <el-table-column
                label="项目名称"
                prop="projectName">
              </el-table-column>
              <el-table-column
                label="项目编号"
                prop="projectCode"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="项目类别"
                prop="proCategoryName"
                width="140px">
              </el-table-column>
              <el-table-column
                label="学分类别"
                prop="creCategoryName"
                width="100px">
              </el-table-column>
              <el-table-column
                label="学分"
                prop="creditSetting"
                width="100px">
                <template slot-scope="scope">
                  {{ scope.row.creditSetting }}分
                </template>
              </el-table-column>
            </el-table>
            <div class="totalModule">
              <div v-for="item in searchFormResult.creditStats">{{ item.name }}合计：{{ item.value }}分</div>
            </div>
            <p class="total">总学分合计：{{ searchFormResult.total }}分</p>
          </div>
        </div>
        <!--右侧3竖模块-->
        <div class="symc_right">
          <login></login>
          <latestNewsSimple></latestNewsSimple>
        </div>
      </div>
      <div class=""></div>
    </div>
    <div style="width: 1002px;margin: 0 auto">
      <footer1></footer1>
    </div>
  </div>
</template>

<script>
import { queryCredit } from '../api/api'
import header2 from '../components/Header2'
import latestNewsSimple from '../components/LatestNewsSimple'
import navigation from '../components/Navigation'
import footer1 from '../components/Footer1'
import login from '../components/Login'
import newsSimpleList from '../components/NewsSimpleList'
import medicalDynamicNews from '../components/MedicalDynamicNews'

export default {
  components: {
    header2,
    footer1,
    navigation,
    login,
    newsSimpleList,
    latestNewsSimple,
    medicalDynamicNews
  },
  data() {
    return {
      searchForm: {
        year: '',
        sertId: ''
      },
      pickerOptions: {
        disabledDate(date) {
          return date.getTime() < new Date('2018-01-01').getTime()
        }
      },
      showSearchResult: false,
      searchFormResult: {
        list: [],
        creditStats: [],
        total: 0,
        user: {}
      },
      searchFormRule: {
        year: {required: true, message: '请选择查询年份！'},
        sertId: {required: true, message: '请选择查询证件号码！'}
      },
      maxheight:0
    }
  },
  mounted() {
    document.getElementById('J_GotoTop').style.visibility = 'hidden'//隐藏在线客服
  },
  destroyed() {
    document.getElementById('J_GotoTop').style.visibility = 'visible' //显示在线客服
  },
  computed: {},
  methods: {
    searchButtonMainInit() {
      this.$refs.searchForm.validate(bool => {
        if (bool) {
          queryCredit({
            sertId: this.searchForm.sertId,
            year: this.searchForm.year,
            source: 'shiyan'
          }).then((res) => {
            if (res.data.code === 0) {
              this.showSearchResult = true
              this.maxheight= window.innerHeight - 210;
              this.searchFormResult.list = res.data.creditList || []
              this.searchFormResult.total = res.data.total || 0
              this.searchFormResult.user = res.data.user || {}
              let list = []
              for (let key in (res.data.creditStats || {})) {
                list.push({
                  name: key,
                  value: res.data.creditStats[key]
                })
              }
              this.searchFormResult.creditStats = list
            }
          })
        }
      })
      
      //   .catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '加载失败！'
      //   });
      // });
    }
  }
}
</script>
<style scoped>
.searchResultModule {
  width: 94%;
 
}
.searchResultModuleTable{
   /* max-height: calc(100vh - 190px); */
   /* overflow: auto; */

}

.totalModule {
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  text-align: left;
}

.totalModule div {
  padding: 5px 20px 5px 0;
  
}

.total {
  font-size: 14px;
  font-weight: bold;
  text-align: right;
  color: #333333;
}

.formTit {
  font-size: 16px;
  line-height: 40px;
  text-align: left;
}

.formInput input {
  font-size: 14px;
  width: 100%;
  height: 40px;
}

.searchStudentModule {
  font-size: 14px;
  line-height: 26px;
  padding-bottom: 10px;
  text-align: left;
  color: #666666;
}

.studentTitle {
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}

.studentTitle:nth-of-type(1) {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/QueryCredit.vue